<template>
    <div :class="data.class" >
        <v-progress-linear 
            :height="data.height" 
            color="transparent" 
            role="progressbar"
            class="bg-transparent" 
            :id="'spacer-'+Math.random()" 
            :title="'spacer-'+Math.random()"
            model-value="0">
        </v-progress-linear>
    </div>
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
}
</script>